import { http, HttpResponse, delay } from 'msw';

import {
  markMockBreachResolved,
  mockDataBreachData,
  toEmployeeBreachDto,
} from '@/mocks/data/employeeBreachData';

const toPaginatedResponse = (breaches: typeof mockDataBreachData) => {
  const results = breaches.map(toEmployeeBreachDto);
  return { results, total: results.length };
};

export const employeeBreachHandlers = [
  http.get('*/v1/organizations/:organizationId/breaches', async () => {
    await delay();
    return HttpResponse.json(toPaginatedResponse(mockDataBreachData), {
      status: 200,
    });
  }),
  http.get(
    '*/v1/organizations/:organizationId/employees/:employeeId/breaches',
    async ({ params }) => {
      const employeeBreaches = mockDataBreachData.filter(
        ({ employee }) => employee.id === params.employeeId
      );
      await delay();
      return HttpResponse.json(toPaginatedResponse(employeeBreaches), {
        status: 200,
      });
    }
  ),
  http.post(
    '*/v1/organizations/:organizationId/employees/:employeeId/breaches/:breachId/resolve',
    async ({ params }) => {
      markMockBreachResolved({
        organizationId: String(params.organizationId),
        employeeId: String(params.employeeId),
        breachId: String(params.breachId),
      });
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
];
